// Widget: Projekt-Statistik — Done/Open-Quote über alle sichtbaren Projekte.

import { useProjects } from "../../store/projects";
import { useUserPrefs } from "../../store/userPrefs";
import { isProjectVisible } from "../../lib/departmentFilter";

export function ProjectStatsWidget(): preact.JSX.Element {
  const projects = useProjects();
  const prefs = useUserPrefs();

  if (projects.loading)
    return <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">Lädt…</p>;

  const visible = projects.items.filter((p) =>
    isProjectVisible(p, prefs.visible_departments)
  );
  const active = visible.filter((p) => p.status === "active");
  const totalTasks = visible.reduce((sum, p) => sum + p.tasks_total, 0);
  const doneTasks = visible.reduce((sum, p) => sum + p.tasks_done, 0);
  const pct = totalTasks > 0 ? Math.round((doneTasks / totalTasks) * 100) : 0;

  return (
    <div class="flex flex-col gap-3 text-sm">
      <div class="grid grid-cols-3 gap-2">
        <Stat label="Aktiv" value={active.length} />
        <Stat label="Gesamt" value={visible.length} />
        <Stat label="Done-Quote" value={`${pct}%`} />
      </div>
      <div>
        <div class="flex items-center justify-between text-label text-[color:var(--color-on-surface-variant)] mb-1">
          <span>Tasks (alle Projekte)</span>
          <span>
            {doneTasks} / {totalTasks}
          </span>
        </div>
        <div class="h-2 rounded bg-[color:var(--color-surface-container-low)] overflow-hidden">
          <div
            class="h-full rounded"
            style={{
              width: `${pct}%`,
              background: "var(--color-status-done)",
            }}
          />
        </div>
      </div>
      <ul class="flex flex-col gap-1">
        {active.slice(0, 5).map((p) => {
          const ppct =
            p.tasks_total > 0
              ? Math.round((p.tasks_done / p.tasks_total) * 100)
              : 0;
          return (
            <li
              key={p.id}
              class="flex items-center gap-2 text-xs text-[color:var(--color-on-surface)]"
            >
              <span
                class="inline-block size-2 rounded-full shrink-0"
                style={{ background: p.color ?? "var(--color-primary)" }}
                aria-hidden="true"
              />
              <span class="flex-1 min-w-0 truncate">{p.name}</span>
              <span class="text-label text-[color:var(--color-on-surface-variant)]">
                {ppct}%
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string | number }): preact.JSX.Element {
  return (
    <div class="rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-low)] px-2 py-1.5 text-center">
      <p class="text-base font-semibold text-[color:var(--color-on-surface)]">{value}</p>
      <p class="text-label uppercase tracking-wider text-[color:var(--color-on-surface-variant)]">
        {label}
      </p>
    </div>
  );
}
